var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-box",class:{
    'is-primary': _vm.primary,
    'is-danger': _vm.danger
  }},[_c('div',{staticClass:"info-box-icon"},[_c('i',{staticClass:"fas",class:{
        'fa-info-circle': _vm.primary,
        'fa-exclamation-triangle': _vm.danger
      }})]),_vm._v(" "),_c('div',{staticClass:"info-box-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }